import React from 'react';
import PrivateRoute from 'PrivateRoutes';
const REPORT = React.lazy(()=> import(/* webpackChunkName: "DesposeReports" */'./components'));

const routes = () => (
  <PrivateRoute exact path="/reporting/despose-report" component={REPORT} />
);

export default routes;



// WEBPACK FOOTER //
// src/modules/screens/reporting/DesposeReport/routes.js